import { ICandidate } from '@/shared/api-client/models/candidate';
import _ from 'lodash';
import { ICandidateViewModel } from '../models/candidate-view-model';

export interface ICandidateBucket {

    candidatesNominatedByCommittee?: ICandidateViewModel[];

    otherCandidates?: ICandidateViewModel[];
}

export class CandidateMapper {

    public static toViewModel(candidates: ICandidate[],
                              showAllCandidatures: boolean,
                              separateCandidatesNominatedByCommittee: boolean,
                              numberCandidatesNominatedByCommittee: boolean,
                              autoCandidateTypeaheadLimit: number): ICandidateBucket {

        const bucket: ICandidateBucket = {};

        if (candidates.length > autoCandidateTypeaheadLimit) {

            showAllCandidatures = false;
        }

        let numbering = 1;

        if (separateCandidatesNominatedByCommittee) {

            bucket.candidatesNominatedByCommittee = _.filter(candidates, (c) => c.nominatedByCommittee)
                .map( (candidate) => {
                return {
                    object: candidate,
                    number: numberCandidatesNominatedByCommittee ? numbering++ : null,
                    alwaysVisible: true,
                    visible: true,
                } as ICandidateViewModel;
            });

            bucket.otherCandidates = _.filter(candidates, (c) => !c.nominatedByCommittee).map( (candidate) => {
                return {
                    object: candidate,
                    alwaysVisible: showAllCandidatures,
                    visible: showAllCandidatures
                } as ICandidateViewModel;
            });

            return bucket;
        }

        // Adding candidates nominated by committee first
        bucket.otherCandidates = _.filter(candidates, (c) => c.nominatedByCommittee).map( (candidate) => {
            return {
                object: candidate,
                number: numberCandidatesNominatedByCommittee ? numbering++ : null,
                alwaysVisible: true,
                visible: true
            } as ICandidateViewModel;
        });

        bucket.otherCandidates = bucket.otherCandidates.concat(
            _.filter(candidates, (c) => !c.nominatedByCommittee).map( (candidate) => {
                return {
                    object: candidate,
                    alwaysVisible: showAllCandidatures,
                    visible: showAllCandidatures
                } as ICandidateViewModel;
            })
        );

        return bucket;
    }
}
